import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    zIndex: 30000,
    overflowY: 'scroll',
  },
  modalTitle: {
    position: 'absolute',
    top: 32,
    fontFamily: 'Roboto',
    fontSize: 21,
    fontWeight: 'bold',
    lineHeight: 1.95,
    letterSpacing: 0.2,
    color: '#fff',
    zIndex: 30002,
  },
  modalOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#172126',
    opacity: 0.95,
    zIndex: 30001,
  },
  modalBox: {
    position: 'relative',
    width: theme.spacing(66.625),
    minHeight: theme.spacing(47),
    boxSizing: 'border-box',
    borderRadius: theme.spacing(1.375),
    backgroundColor: '#FFFFFF',
    cursor: 'auto',
    zIndex: 30003,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      height: '50%',
      aspectRatio: 261 / 71.33,
      margin: theme.spacing(2.5),
    },
  },
  modalContent: {
    marginTop: theme.spacing(8.75),
    color: '#000000',
    fontSize: 16,
    fontWeight: 'bold',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  modalCloseButton: {
    position: 'absolute',
    top: theme.spacing(-0.25),
    left: theme.spacing(-2.25),
    backgroundColor: 'transparent',
    zIndex: 30001,
  },
  backIcon: {
    width: theme.spacing(2.15),
    height: theme.spacing(2.15),
  },
}));
